'use client'
import React from 'react'
import MyImage from '../../myImage'
import Grid from '@/assets/images/Grid.svg'
import GridDark from '@/assets/images/grid-dark.svg'

interface VenueWinProps {
  venueStatsData: any
}

const VenueWin: React.FC<VenueWinProps> = ({ venueStatsData }) => {
  const batPercentage = (venueStatsData?.nFirstBatWin / venueStatsData?.nTotalMatches) * 100
  const bowlPercentage = (venueStatsData?.nFirstBowlWin / venueStatsData?.nTotalMatches) * 100

  // Fixed percentages
  const pinkPercentage = batPercentage < bowlPercentage ? batPercentage : bowlPercentage
  const greenPercentage =
    batPercentage > bowlPercentage
      ? batPercentage
      : bowlPercentage + (100 - batPercentage > bowlPercentage ? batPercentage : bowlPercentage)

  // SVG parameters
  const radius = 42
  const strokeWidth = 4
  const centerX = 50
  const centerY = 50

  const generateHalfCirclePath = () => {
    return `M ${centerX - radius}, ${centerY} a ${radius},${radius} 0 0,1 ${radius * 2},0`
  }
  const circumference = radius * Math.PI
  const pinkLength = (pinkPercentage / 100) * circumference
  const greenLength = (greenPercentage / 100) * circumference

  return (
    <div className=" bg-cardBg border md:border-0 border-borderStroke md:bg-headersActive py-4 md:pt-[30px] md:pb-7 pl-4 pr-[60px] md:px-[18px] rounded-xl flex gap-8 md:gap-0 md:block flex-row items-center mb-4 md:mb-0">
      <div className="relative pb-12 flex-shrink-0 w-[86px] md:w-full">
        <svg viewBox="0 0 100 60" className="dark:hidden">
          <path
            d={generateHalfCirclePath()}
            fill="none"
            stroke="#222"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
          />

          <path
            d={generateHalfCirclePath()}
            fill="none"
            stroke="#E8503A"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={`${pinkLength} ${circumference}`}
            strokeDashoffset="0"
          />

          {/* Green segment (right side) */}
          <path
            d={generateHalfCirclePath()}
            fill="none"
            stroke="#00A632"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={`${greenLength} ${circumference}`}
            strokeDashoffset={`${-pinkLength}`}
          />

          {/* Label */}
        </svg>
        <svg viewBox="0 0 100 60" className="dark:block hidden">
          <path
            d={generateHalfCirclePath()}
            fill="none"
            stroke="#222"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
          />

          <path
            d={generateHalfCirclePath()}
            fill="none"
            stroke="#802D41"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={`${pinkLength} ${circumference}`}
            strokeDashoffset="0"
          />

          {/* Green segment (right side) */}
          <path
            d={generateHalfCirclePath()}
            fill="none"
            stroke="#4F5B29"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={`${greenLength} ${circumference}`}
            strokeDashoffset={`${-pinkLength}`}
          />

          {/* Label */}
        </svg>
        <div className="text-center absolute top-2/4  md:top-[44%] left-1/2 transform -translate-x-1/2 -translate-y-1/2">
          <p className="text-xxs md:text-xl dark:text-white/30 text-[#80878D] mb-1 md:mb-3">
            Matches
          </p>
          <p className="text-[#80878D] dark:text-white font-bold text-2xl md:text-[50px]">
            {venueStatsData?.nTotalMatches}
          </p>
        </div>
        <div className=" absolute -bottom-1 left-2/4 -translate-x-2/4 w-full">
          <MyImage className=" dark:hidden block mx-auto w-full" src={Grid} />
          <MyImage className=" dark:block hidden mx-auto w-full" src={GridDark} />
        </div>
      </div>
      <div className="flex-grow">
        <div className="flex items-center justify-between gap-3 border-b border-borderStroke pb-3 md:pb-3.5">
          <p className="text-xs md:text-base font-bold text-TextScoredCompplete">Win Bat First</p>
          <span
            className={`font-bold text-base md:text-xl ${batPercentage < bowlPercentage ? 'text-textRed' : 'text-textGreen'}`}
          >
            {venueStatsData?.nFirstBatWin !== undefined
              ? `${((venueStatsData.nFirstBatWin / venueStatsData.nTotalMatches) * 100).toFixed(2)}%`
              : '--'}
          </span>
        </div>
        <div className="flex items-center justify-between gap-3 pt-3 md:pt-5">
          <p className="text-xs md:text-base font-bold text-TextScoredCompplete">Win Bowl First</p>
          <span
            className={`font-bold text-base md:text-xl ${batPercentage > bowlPercentage ? 'text-textRed' : 'text-textGreen'}`}
          >
            {venueStatsData?.nFirstBowlWin !== undefined
              ? `${((venueStatsData.nFirstBowlWin / venueStatsData.nTotalMatches) * 100).toFixed(2)}%`
              : '--'}
          </span>
        </div>
      </div>
    </div>
  )
}

export default VenueWin
